import React from "react";

const ClientsSection = ({ clientsRef, showClients, presenter }) => {
  console.log(presenter);
  return (
    <div
      ref={clientsRef}
      style={{ backgroundColor: "#ffffff", padding: "60px 0" }}
    >
      <div
        className="container text-center"
        style={{
          opacity: showClients ? 1 : 0,
          animation: showClients ? `zoomInCenter 0.6s ease forwards` : "none",
          animationDelay: "0.3s",
        }}
      >
        <h2 className="fw-bold mb-5" style={{ color: "#011601" }}>
          Our Valued Clients
        </h2>
        <div className="row justify-content-center">
          {presenter?.map((client, index) => (
            <div className="col-6 col-md-3 mb-4" key={index}>
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#ffffff" }}
              >
                <div className="client-content">
                  <img
                    className="client-image"
                    src={client.logo}
                    alt={client.name}
                  />
                </div>
                <h6 className="mt-3 mb-0">{client.name}</h6>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientsSection;
